// Having access to the arrow as an SVG shape in your HTML allows you to use
// CSS to dynamically update the arrow's fill color (by selecting the polygon).
// We use this to have the arrow's fill inherit the color of its container,
// which makes the arrow blue if its in a link.
import React from "react";

const component = (props) =>
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.58 32.46">
    <polygon points="36.58 16.25 20.45 0 17.16 3.18 27.95 13.98 0 13.98 0 18.48 28.03 18.48 17.16 29.27 20.45 32.46 36.58 16.3 36.56 16.28 36.58 16.25"/>
  </svg>

component.displayName = 'ArrowSvg';
export default component;


// WEBPACK FOOTER //
// ./client/components/ArrowSvg/index.js